import React from 'react';
import { Link } from 'react-router-dom';

interface SidebarSubmenuItemProps {
  name: string;
  path?: string;
  isActive?: boolean;
  onClick?: () => void;
  onAction?: () => void;
}

const SidebarSubmenuItem = ({ name, path, isActive, onClick, onAction }: SidebarSubmenuItemProps) => (
  <li className={`sidebar-submenu-item ${isActive ? 'selected' : ''}`}>
    {path ? (
      <Link to={path} onClick={onClick}>
        {name}
      </Link>
    ) : (
      <button type="button" onClick={onAction ?? onClick}>
        {name}
      </button>
    )}
  </li>
);

export default SidebarSubmenuItem;
